// extracted by mini-css-extract-plugin
export default {"productDescription":"Mda-z","featuredDescription":"Nda-z","description":"Oda-z","more":"Pda-z","descriptionSku":"Qda-z"};